var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64014 7C1.64014 7 4.64014 1 9.89014 1C15.1401 1 18.1401 7 18.1401 7C18.1401 7 15.1401 13 9.89014 13C4.64014 13 1.64014 7 1.64014 7Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89014 9.25C11.1328 9.25 12.1401 8.24264 12.1401 7C12.1401 5.75736 11.1328 4.75 9.89014 4.75C8.6475 4.75 7.64014 5.75736 7.64014 7C7.64014 8.24264 8.6475 9.25 9.89014 9.25Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/EyeOn.a82f6862118ccbc967f0e85817966c5d.svg";
export { ForwardRef as ReactComponent };